import * as QuickSightEmbedding from "amazon-quicksight-embedding-sdk";
import React, { useEffect, useState, useRef } from "react";
import { useStateValue } from "../Hooks/stateProvider";
import './AnalyticsDashboard.css'
import axios from "axios";
import { ls } from "../variables";
import { makeStyles } from "@mui/styles";
import { Card, CardContent, IconButton } from "@mui/material";
import swal from "sweetalert";
import Styles from '../layouts/PMSComponents/alertModule/styles/main.module.css'
import Download from '@mui/icons-material/GetApp';
import { Breadcrumbs, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";



const useDialogStyles = makeStyles((theme) => ({
    dialog: {
        // padding: theme.spacing(2),
        position: "absolute",
        //top: theme.spacing(20),
    },
    dialogTitle: {
        textAlign: "center",
        color: '#154063'
    },
    dialogContent: {
        textAlign: "center",
        display: "flex",
        marginBottom: "20px"
    },
    dialogAction: {
        justifyContent: "center",
        marginTop: "20px"
    },
    titleIcon: {
        backgroundColor: "#154063",
        color: "whitesmoke",
        // boxShadow: "var(--softUIEffect-1)",
        padding: "12px",
        "&:hover": {
            backgroundColor: "#154063",
            cursor: "default",
        },
        "& .MuiSvgIcon-root": {
            fontSize: "8rem",
        },
    },
    button: {
        background: "#154063",
        color: "white",
        // boxShadow: "var(--softUIEffect-1)",
        marginRight: "8px",
        "&:hover": {
            opacity: "0.8",
            backgroundColor: "#154063"
        },
        "& :path": {
            fontSize: 20,
            webkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
        },
    },
}))


const AnalyticsDashboard = (props) => {

    const [state, dispatch] = useStateValue();
    const [reportName, setType] = useState("MSR")
    const [dashboard, setDashboard] = useState(null)
    const navigate = useNavigate();

    let user = ls.get('userType');
    let reportNameMap;

    //     useEffect(() => {

    //         axios.post(`/api/getdmsStatus` ,{ token: reactLocalStorage.get("token")})
    //                .then((response) => {

    //                    let date = response.data.success_date
    //                    if (moment(date, "YYYY-MM-DD", true).isValid()){
    //                        setsuccess_date( moment(date).format("Do MMM YYYY"));   
    //                    } 

    //                })
    //    },[])

    useEffect(() => {
        if (user === 'APMII') {
            reportNameMap = {
                "pms": props.id,
            }
        } else {
            reportNameMap = {
                "pms": "",
            }
        }
    }, [user])

    const embeddingContainer = useRef(null)

    const dialogClasses = useDialogStyles()

    // function handleSubscription() {
    //     // dispatch({ type: "SHOW_LOADER" });

    //     let id = reportNameMap[reportName]
    //     let email = "sanyog.ghosh@kfintech.com"
    //     axios
    //         .get(`/api/handleSubscription?key=${id}`)
    //         .then(function (result) {
    //             dispatch({ type: "HIDE_LOADER" });

    //             if (result.data.success) {
    //                 swal(`Subscribed Successfully`, "You will receive Quicksight Reports!", "success");

    //             } else {
    //                 swal(`Subscription Failed !`, "You were not granted permission to access reports!", "error");


    //             }

    //         });

    // }

    function handleDownload() {
        try {
            dashboard.initiatePrint();
        }
        catch (e) {
            swal(`Download Failed`, "Failed to download report", "error");
        }
    }

    function onDashboardLoad(payload) {
        // console.log(payload, dashboard)
        dispatch({ type: "HIDE_LOADER" });

        // var paragraphCount = document.evaluate('/html/body/div[4]/div[2]/div/div/div[2]/div[2]/div/div/div[2]/div/div/div[1]', document, null, XPathResult.ANY_TYPE, null );
        // console.log("count", paragraphCount)
        var iframe = document.getElementsByClassName('quicksight-embedding-iframe');
        var innerDoc = iframe;
        // console.log(innerDoc)
        // console.log(document.getElementsByClassName('quicksight-embedding-iframe'))
    }

    useEffect(() => {
        dispatch({ "type": "HIDE_LOADER" })
    }, [])


    useEffect(() => {
        (async () => {
            //Generate dashboard URL
            embeddingContainer.current.innerHTML = "";

            // let key = state.darkTheme ? (darkTheme[reportName] || reportNameMap[reportName]) : reportNameMap[reportName]

            console.log(embeddingContainer.current)

            await axios
                .get(`/api/embed?Id=${reportNameMap.pms}`)
                .then((data) => {
                    // console.log("url is working");
                    // console.log(data)
                    var embedUrl = data.data.EmbedUrl;
                    // dispatch({ type: "SHOW_LOADER" });

                    var options = {
                        url: embedUrl,
                        container: embeddingContainer.current,
                        themeId: "arn:aws:quicksight::aws:theme/MIDNIGHT"
                    };
                    let dashboard;
                    try {
                        dashboard = QuickSightEmbedding.embedDashboard(options)
                        dispatch({ type: "SHOW_LOADER" });
                        dashboard.on("load", onDashboardLoad)
                    }
                    catch (e) { console.log("error>>", e) };

                    setDashboard(dashboard)
                    // dispatch({ "type": "SHOW_LOADER" })

                });
        })();


    }, [reportName]);





    return (
        <div style={{ overflow: "hidden", whiteSpace: "nowrap", overflow: "scroll" }}>
            {/* <Information content={PWMAnalyticsPara} heading={"Guide"}></Information> */}
            <div >
                <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb" style={{ marginLeft: "30px" }}>
                    <Link
                        underline="hover"
                        color="inherit"
                    >
                        Analytics
                    </Link>
                </Breadcrumbs>
            </div>
            <Card
                style={{ overflow: "auto", whiteSpace: "nowrap", margin: "10px", height: "100vh", padding: "0px", borderRadius: "20px 20px 0px 0px", display: "flex", flexDirection: "column" }}
            >
                <CardContent>
                    {/* <Loader /> */}
                    <div style={{ display: "flex", flexDirection: "row", marginTop: "-25px" }}>

                        <div className="sebi_header_container">

                            <p className="welcome_note">Analytics Dashboard</p>

                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>

                            {/* { sucess_date &&  (<p style={{color:"#000"}}>Data as of {sucess_date}</p>)} */}
                            <IconButton
                                data-tip="Download Report"
                                className={dialogClasses.button}
                                onClick={() => handleDownload()}
                                style={{ marginLeft: "10px" }}
                            >
                                <Download />
                            </IconButton>
                            {/* <IconButton
                                data-tip="Info"
                                className={dialogClasses.button}
                                onClick={() => dispatch({ "type": "SHOW_DIALOG" })}
                                style={{ marginLeft: "10px" }}
                            >
                                <Info />
                            </IconButton> */}
                            {/* <IconButton
                                data-tip="Subscribe"
                                className={dialogClasses.button}
                                // onClick={() => handleSubscription()}
                                style={{ marginLeft: "10px" }}
                            >
                                <Mail />
                            </IconButton> */}
                            {/* <IconButton
                                data-tip="Upload Data"
                                className={dialogClasses.button}
                                onClick={() => setDialog(true)}
                                style={{ marginLeft: "10px" }}
                            >
                                <Upload />
                            </IconButton> */}

                            {/* 
                            <Button
                                style={{
                                    margin: "10px 10px 0px 0px", color: "white",
                                    width: "200px",
                                    boxShadow: "var(--softUIEffect-1)",
                                    background: "var(--color-KfinBlue)"
                                }}
                                onClick={() => setDialog(true)}
                            >
                                UPLOAD
                            </Button> */}
                        </div>
                    </div>
                </CardContent>
                <CardContent style={{
                    display: "flex",
                    flex: "10"
                }}>
                    <div style={{
                        boxShadow: "var(--softUIEffect-1)",
                        flex: "1"
                    }}>
                        <>
                            {/* <div style={{height:"1px", background:"var(--color-KfinBlue)"}}>aa</div> */}

                            <div
                                style={{
                                    justifyItems: "center",
                                    height: "76vh",
                                }}
                                ref={embeddingContainer}
                            >
                                { }
                            </div>
                        </>
                    </div>

                </CardContent>
            </Card>
            {/* <Loader /> */}
        </div>

    )
}

export default AnalyticsDashboard